import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { GetCurrentUserQuery } from "generated/graphql";

const TTL_MS = 3_000;

interface CurrentUserCacheState {
  fetchedAt: number | null;
  invalidate: () => void;
  isStale: () => boolean;
  setUser: (user: GetCurrentUserQuery["currentUser"]) => void;
  user: GetCurrentUserQuery["currentUser"] | null;
}

export const useCurrentUserCacheStore = create<CurrentUserCacheState>()(
  devtools(
    (set, get) => ({
      fetchedAt: null,
      user: null,
      isStale: () => {
        const { fetchedAt } = get();
        return !fetchedAt || Date.now() - fetchedAt > TTL_MS;
      },
      setUser: user => set({ user, fetchedAt: Date.now() }),
      invalidate: () => set({ user: null, fetchedAt: null }),
    }),
    { name: "CurrentUserCacheStore" },
  ),
);
